import React from 'react'
import '../App.css';

export default function Button1 ({props}) {
  return (

    <span className=''>
        <button className='button1'> {props} </button>
    </span>
    
  )
}
